import React from 'react'

import './sidebar.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import CloseButton from '../../../../commons/src/components/close-button'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    header?: React.ReactNode
    footer?: React.ReactNode
    title?: React.ReactNode
    children: React.ReactNode
    scrollContainerRef?: React.RefObject<HTMLDivElement>
    onClose?: React.MouseEventHandler
  }
>

// TODO move this commons package once ccds is integrated into craftcloud
const Sidebar = ({
  className,
  header,
  footer,
  children,
  title,
  scrollContainerRef,
  onClose,
  ...props
}: Props) => (
  <div {...props} className={cn('Sidebar', {}, className)}>
    {header && <div className="Sidebar__header">{header}</div>}
    <div className="Sidebar__main" ref={scrollContainerRef}>
      {title && (
        <div className="Sidebar__titleHeader">
          <div className="Sidebar__title">{title}</div>
          {onClose && (
            <div className="Sidebar__close">
              <CloseButton onClick={onClose} />
            </div>
          )}
        </div>
      )}
      <div className="Sidebar__children">{children}</div>
    </div>
    {footer && <div className="Sidebar__footer">{footer}</div>}
  </div>
)

export default Sidebar
